import { SharedCommonModule } from "@app/shared/common";
import { SharedUiModule } from "@app/shared/ui";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule, HammerModule } from "@angular/platform-browser";

import { AppComponent } from "./app.component";
import { RouterModule } from "@angular/router";
import { appRoutes } from "./app.routes";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { StoreModule } from "@ngrx/store";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { configReducer } from "./core/reducers/config.reducer";
import { SharedComponentsModule } from "@app/shared/components";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppConfigService } from "./core/services/app-config.service";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { JwtCmsInterceptor, ErrorInterceptor } from "@app/core/authentication";
import { ConfirmationService } from "primeng/api";
import {
  DialogService,
  DynamicDialogRef,
  DynamicDialogConfig,
} from "primeng/dynamicdialog";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";

export function configFactory(config: AppConfigService) {
  return () => config.load();
}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes, { initialNavigation: "enabledBlocking" }),
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedUiModule,
    HammerModule,
    FormsModule,
    SharedCommonModule,
    SharedComponentsModule,
    // SortablejsModule.forRoot({ animation: 150 }),
    StoreModule.forRoot({ config: configReducer }),
    TranslateModule.forRoot({
      defaultLanguage: localStorage.getItem("cmsLanguage") || "en",
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    AppConfigService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtCmsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      deps: [AppConfigService],
      multi: true,
    },
    ConfirmationService,
    DialogService,
    DynamicDialogRef,
    DynamicDialogConfig,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
